module.exports = __webpack_public_path__ + "img/20210823_123711.fc9819e3.jpg";